import $ from 'jquery';
import filter from 'lodash/filter';
import find from 'lodash/find';
import first from 'lodash/first';
import forEach from 'lodash/forEach';
import get from 'lodash/get';
import pull from 'lodash/pull';
import reporter from '../../../js/ads/reporter';
import adsSettings from '../../../js/utils/adsSettings';
import { State, addStateChangeListener, getState, } from '../../../js/utils/applicationState';
import parseUtils from '../../../js/utils/parseUtils';
import { v4 as uuidv4 } from 'uuid';
const onCanShowAdsChange = function () {
    if (!adsSettings.canShowAds() && this.canShowAds) {
        forEach(this.slotArray, (slot) => {
            this.clearSlot(slot);
            this.releaseSlot(slot);
        });
    }
    this.canShowAds = adsSettings.canShowAds();
};
const fallbackNetworkController = {
    slotArray: [],
    init() {
        this.canShowAds = adsSettings.canShowAds();
        addStateChangeListener(State.selectedGuideId, onCanShowAdsChange.bind(this));
        addStateChangeListener(State.playerStatus, onCanShowAdsChange.bind(this));
    },
    registerSlot(slot) {
        this.slotArray.push(slot);
    },
    deregisterSlot(slot) {
        const slotData = find(this.slotArray, ['elementId', slot.elementId]);
        pull(this.slotArray, slotData);
    },
    serveAd(slot) {
        return new Promise((resolve) => {
            const options = getState(State.options);
            const bannerAdsEnabled = parseUtils.parseBool(get(options, 'bannerads.enabled', true));
            if (!(slot && adsSettings.canShowAds() && bannerAdsEnabled)) {
                resolve();
                return;
            }
            const format = first(filter(slot.formats, ['adProvider', 'fallback']));
            if (!format) {
                resolve();
                return;
            }
            slot.requestId = uuidv4().toString();
            this.renderFallback(slot, format);
            reporter.impression(slot);
            resolve();
        });
    },
    clearSlot(slot) {
        if (slot) {
            const $slotEl = $(`#${slot.elementId}`);
            if ($slotEl) {
                $slotEl.empty();
                $slotEl.off();
            }
        }
    },
    releaseSlot() { },
    getAssetName(format) {
        const fileName = `fallback_${format.dimensions[0][0]}x${format.dimensions[0][1]}.png`;
        return `${getState(State.assetLocation)}assets/img/${fileName}`;
    },
    renderFallback(slot, format) {
        const src = this.getAssetName(format);
        let html = '<a href="/premium" target="_blank">';
        html += `<div style="width: ${format.dimensions[0][0]}px;`;
        html += ` height: ${format.dimensions[0][1]}px;`;
        html += ` background-image: url(\'${src}\'); display: inline-block;"></div></a>`;
        $(`#${slot.elementId}`).html(html);
    },
};
export default fallbackNetworkController;
